import { render, staticRenderFns } from "./goods_sale.vue?vue&type=template&id=22cdea65&scoped=true&"
import script from "./goods_sale.vue?vue&type=script&lang=ts&"
export * from "./goods_sale.vue?vue&type=script&lang=ts&"
import style0 from "./goods_sale.vue?vue&type=style&index=0&id=22cdea65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cdea65",
  null
  
)

export default component.exports